import { useState } from 'react';
import MarketingAIChat from '@/components/MarketingAIChat';
import { PageHeader } from '@/components/PageHeader';

export default function AdminAIChatPage() {
  return (
    <div className="h-[calc(100vh-7rem)]">
      <PageHeader title="marKI Chat" description="Ihr KI-gestützter Marketing-Berater für alle Fragen rund um App-Wachstum" />
      <div className="h-[calc(100%-4rem)] rounded-xl overflow-hidden border border-slate-200">
        <MarketingAIChat embedded={true} />
      </div>
    </div>
  );
}
